import { useContext } from 'react';
import useAtlasAuth from './services/atlas/useAtlasAuth';
import { AuthContext, AuthContextType } from './AuthenticationProvider';

interface AuthProvider {
	signOut: () => void;
}

type AuthProviders = {
	[key: string]: AuthProvider;
};

function useAuth(): AuthContextType & { signOut: () => void } {
	const context = useContext(AuthContext);
	const { signOut: atlasSignOut } = useAtlasAuth()

	if (!context) throw new Error('useAuth must be used within a AuthRouteProvider');

	const authProviders: AuthProviders = {
		atlas: { signOut: atlasSignOut }
	};

	const signOut = () => {
		const authProvider = context.getAuthProvider();
		authProviders[authProvider]?.signOut();
	};

	return { ...context, signOut };
}

export default useAuth;
